module.exports = __webpack_public_path__ + "img/icn_circle_bordered.97e5b8f8.svg";